import services from 'api/services';
import { logError } from 'global/errors';

import {
  LOAD_CONTEST_REQUEST,
  LOAD_CONTEST_SUCCESS,
  LOAD_CONTEST_FAILURE,
  LOAD_RANK_LIST_REQUEST,
  LOAD_RANK_LIST_SUCCESS,
  LOAD_RANK_LIST_FAILURE,
  CREATE_RUN_REQUEST,
  CREATE_RUN_SUCCESS,
  CREATE_RUN_FAILURE,
  CREATE_CONTINUOUS_REQUEST,
  CREATE_CONTINUOUS_SUCCESS,
  CREATE_CONTINUOUS_FAILURE,
} from './constants';

const { ChallengeService } = services;

export const getContestForCMS = (contestId) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_CONTEST_REQUEST });
    const response = await ChallengeService.getContestForCMS(contestId);
    dispatch({ type: LOAD_CONTEST_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_CONTEST_FAILURE, error: ex.message });
  }
};

export const getRankList = (contestId, isTournament) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_RANK_LIST_REQUEST });
    const response = isTournament
      ? await ChallengeService.getTournamentRankList(contestId)
      : await ChallengeService.getChallengeRankList(contestId);
    dispatch({
      type: LOAD_RANK_LIST_SUCCESS,
      data: isTournament ? response.leaderboard : response,
      isSessionRunning: response.isSessionRunning,
    });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_RANK_LIST_FAILURE, error: ex.message });
  }
};

export const runTournament = (contestId, body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_RUN_REQUEST });
    const response = await ChallengeService.runTournament(contestId, body);
    dispatch({ type: CREATE_RUN_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_RUN_FAILURE, error: ex.message });
  }
};

export const continuousRunningTournament = (contestId, body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CONTINUOUS_REQUEST });
    const response = await ChallengeService.continuousRunningTournament(contestId, body);
    dispatch({ type: CREATE_CONTINUOUS_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_CONTINUOUS_FAILURE, error: ex.message });
  }
};
